<template>
    <HeaderList v-if="!loading">
        <template #content>
            <router-link :to="{ name: 'audiences' }" class="back-link-type-1">
                <div class="p">{{$t('views.audience.buttons.back')}}</div>
            </router-link>
            <h1 class="name">{{ audience.name || '-' }}</h1>
            <p v-html="$t('views.audience.description', { total: formatNumber(audience.stats?.suspects || audience.total || 0), date: epochToDisplayDate(audience.changed_time || 0)})"></p>
        </template>
    </HeaderList>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAudienceStore } from '@/stores/audience';
    import { epochToDisplayDate } from '@/utils/dates';
    import { formatNumber } from '@/utils/formatting';
    import HeaderList from '@/components/sections/HeaderList';

    export default {
        name: "AudienceHeader",
        components: {
            HeaderList
        },
        computed: {
            ...mapState(useAudienceStore, ['audience', 'loading']),
        },
        methods: {
            epochToDisplayDate,
            formatNumber
        }
    }
</script>
